var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import UITextArea from './UITextArea';
const TextArea = (_a) => {
    var { onChange } = _a, restProps = __rest(_a, ["onChange"]);
    const [count, setCount] = useState(0);
    const handleOnChange = (event) => {
        if (event && event.target)
            setCount(event.target.value.replace(/\s+/g, '').length);
        else
            setCount(0);
        if (onChange) {
            onChange(event);
        }
    };
    useEffect(() => {
        if (restProps.value) {
            setCount(restProps.value.length);
        }
    }, [restProps.value]);
    return React.createElement(UITextArea, Object.assign({ onChange: handleOnChange, count: count }, restProps));
};
export default React.memo(React.forwardRef((props, ref) => {
    return React.createElement(TextArea, Object.assign({ innerRef: ref }, props));
}));
//# sourceMappingURL=TextArea.js.map